"use client";

import { useId, useState } from "react";
import type { DemoStage, IconName } from "@/lib/types";
import { Icon } from "./icon";

export function DemoPreview({ stages, icon }: { stages: DemoStage[]; icon: IconName }) {
  const [active, setActive] = useState(0);
  const id = useId();
  const stage = stages[active];

  return (
    <div className={`demo-window demo-window--${icon}`}>
      <div className="demo-window-bar"><span></span><span></span><span></span><div className="demo-address">flowcuz / demonstration</div></div>
      <div className="demo-window-body">
        <aside className="demo-sidebar" aria-hidden="true"><div className="demo-app-icon"><Icon name={icon} size={18}/></div><i></i><i></i><i></i><i></i></aside>
        <div className="demo-content">
          <div className="demo-tabs" role="tablist" aria-label="Demonstration stages">
            {stages.map((item, index) => (
              <button id={`${id}-tab-${index}`} aria-controls={`${id}-panel`} aria-selected={active === index} key={item.label} onClick={() => setActive(index)} role="tab" tabIndex={active === index ? 0 : -1}>{item.label}</button>
            ))}
          </div>
          <div className="demo-stage" id={`${id}-panel`} role="tabpanel" aria-labelledby={`${id}-tab-${active}`}>
            <div className="demo-stage-top"><span className="demo-live-dot"></span><span>{stage.eyebrow}</span></div>
            <strong>{stage.title}</strong>
            <p>{stage.detail}</p>
            <div className="demo-preview-art" aria-hidden="true"><i></i><i></i><i></i></div>
            <div className="demo-meta"><span>{stage.meta}</span><span className="demo-check">✓</span></div>
          </div>
        </div>
      </div>
    </div>
  );
}
